export default __webpack_public_path__ + "static/media/GothamSSm-Medium.240c2ea7.svg";